export default {
  'moduleTitle.address': 'Adresa',
  'moduleTitle.address_details': 'Podrobnosti adresy',
  'moduleTitle.activity_details': 'Podrobnosti aktivity',
  'moduleTitle.add_log': 'Pridať záznam',
  'moduleTitle.award_level': 'Úroveň DofE',
  'moduleTitle.adventurous_journey': 'Dobrodružná expedícia',
  'moduleTitle.already_assessed': 'Už zhodnotené!',
  'moduleTitle.approved': 'Schválené!',
  'moduleTitle.assessor_details': 'Podrobnosti Hodnotiteľa',
  'moduleTitle.authorising_contact_license_holder': 'Autorizácia kontaktu/držiteľa licencie',
  'moduleTitle.category_journey_details': 'Podrobnosti expedície v kategórii {category}',
  'moduleTitle.complete_report': 'Vyplniť hodnotenie',
  'moduleTitle.completed_progress': 'Dokončené {finished}/{total}',
  'moduleTitle.congratulation': 'Gratulujeme!',
  'moduleTitle.confirming_email_address': 'Potvrdzuje emailovú adresu ...',
  'moduleTitle.contact_details': 'Kontaktné údaje',
  'moduleTitle.edit_log': 'Upraviť záznam',
  'moduleTitle.event_journey': '{event} expedícia',
  'moduleTitle.forgotten_password': 'Zabudnuté heslo',
  'moduleTitle.great_you_are_almost_there': 'Výborne, už si skoro tam. Posledným krokom je platba za novú úroveň DofE.',
  'moduleTitle.home_address': 'Adresa domov',
  'moduleTitle.journey_overview': 'Prehľad expedície',
  'moduleTitle.log_detail': 'Podrobnosti záznamu',
  'moduleTitle.login': 'Prihlásenie',
  'moduleTitle.new_activity': 'Nová aktivita',
  'moduleTitle.new_event_journey': 'Nová udalosť {event} expedície',
  'moduleTitle.new_residential_project': 'Nový rezidenčný projekt',
  'moduleTitle.notRegistred': 'Bez registrácie?',
  'moduleTitle.nominated_award_leader_contact_details': 'Kontaktné údaje nominovaného Vedúceho programu',
  'moduleTitle.nominated_award_leader': 'Nominovaný Vedúci programu',
  'moduleTitle.organisation_address': 'Adresa organizácie',
  'moduleTitle.organisation_details': 'Podrobnosti organizácie',
  'moduleTitle.online_record_book_account': 'Konto Online Účastníckej knižky',
  'moduleTitle.page_not_found': '404 - Stránka nenájdená',
  'moduleTitle.personal_details': 'Osobné údaje',
  'moduleTitle.preparation_and_training': 'Príprava a tréning',
  'moduleTitle.profile_guardian_consent': 'Súhlas rodiča/poručníka',
  'moduleTitle.profile_questions': 'Profilové otázky',
  'moduleTitle.registration_for_level': 'Registrácia na novú úroveň',
  'moduleTitle.residential_project': 'Rezidenčný projekt',
  'moduleTitle.residential_project_details': 'Podrobnosti rezidenčného projektu',
  'moduleTitle.reset_password': 'Resetovať heslo',
  'moduleTitle.welcome_to_the_orb': 'Vitajte v Online Účastníckej knižke',
  'moduleTitle.we_have_sent_you_an_email': 'Poslali sme e-mail s prepojením na aktiváciu.',
  'moduleTitle.your_registration_is_complete': 'Tvoja registrácia je hotová.',
  'formTitle.activity_details': 'Podrobnosti aktivity',
  'formTitle.assessor_details': 'Podrobnosti Hodnotiteľa',
  'formTitle.supervisors_details': 'Podrobnosti školiteľa',
  'formTitle.preparation_and_training_activities': 'Prípravné a tréningové aktivity',
  'formTitle.added_preparation_activities': 'Pridali sa prípravné a tréningové aktivity',
  'label.add_picture': 'Pridať fotku',
  'label.address_first_line': 'Prvý riadok adresy',
  'label.address_second_line': 'Druhý riadok adresy (nepovinné)',
  'label.are_you_already_running_award': 'Poskytujete už DofE?',
  'label.are_you_the_main_award_leader': 'Ste hlavným Vedúcim programu alebo koordinátorom Miestneho centra?',
  'label.award_participant': 'Účastník DofE',
  'label.award_leader': 'Vedúci programu DofE',
  'label.birthdate': 'Dátum narodenia',
  'label.category': 'Kategória',
  'label.change_locale': 'Zmeniť miesto',
  'label.choose_project': 'Vybrať projekt',
  'label.city': 'Mesto',
  'label.choose_as_major_activity': 'Vybrať ako hlavnú aktivitu',
  'label.date': 'Dátum',
  'label.date_of_birth': 'Dátum narodenia',
  'label.description_of_progress': 'Popis tvojho postupu',
  'label.duration': 'Trvanie (v min)',
  'label.email': 'E-mail',
  'label.email_address': 'E-mailová adresa',
  'label.email_again': 'E-mail znova',
  'label.employment_status': 'Stav zamestnania',
  'label.end_date': 'Dátum dokončenia',
  'label.enter_his_email': 'Zadať e-mailovú adresu',
  'label.entered_transaction_id': 'Vaše ID transakcie',
  'label.first_name': 'Meno',
  'label.gender': 'Pohlavie',
  'label.goal': 'Cieľ',
  'label.journey_activity': 'Aktivita týkajúca sa expedície',
  'label.journey_objective': 'Účel expedície',
  'label.journey_observations': 'Pozorovania počas expedície',
  'label.journey_type': 'Typ expedície',
  'label.last_name': 'Priezvisko',
  'label.level': 'Úroveň',
  'label.location': 'Miesto',
  'label.logout': 'Odhlásenie',
  'label.major': 'Hlavná aktivita',
  'label.middle_name': 'Druhé meno',
  'label.mode_of_transport': 'Spôsob presunu',
  'label.my_award_leader': 'Môj Vedúci programu',
  'label.name': 'Meno',
  'label.nationality': 'Národnosť',
  'label.no': 'Nie',
  'label.no_results': 'Žiadne výsledky',
  'label.note': 'Poznámka',
  'label.note_for_assessor': 'Poznámka pre Hodnotiteľa',
  'label.note_for_leader': 'Poznámka pre Vedúceho',
  'label.optional': 'nepovinné',
  'label.organisation_name': 'Názov organizácie',
  'label.organisation_type': 'Typ organizácie',
  'label.others': 'Iné',
  'label.password': 'Heslo',
  'label.password_again': 'Zopakovať heslo',
  'label.project_location': 'Miesto projektu',
  'label.pay_online': 'Platba online',
  'label.pay_award_leader_or_unit': 'Platba Vedúcemu programu alebo Miestnemu centru',
  'label.payment_not_required': 'Platba nie je vyžadovaná',
  'label.payment_type': 'Typ platby:',
  'label.phone': 'Telefón',
  'label.phone_number': 'Telefónne číslo',
  'label.phone_type': 'Typ telefónu',
  'label.profile': 'Profil',
  'label.reset_password': 'Resetovať heslo',
  'label.region': 'Štát/okres/región',
  'label.relationship': 'Vzťah',
  'label.role_in_organisation': 'Rola v organizácii',
  'label.select_country': 'Výber krajiny',
  'label.select_your_au': 'Vyber svoje Miestne centrum',
  'label.start_typing': 'Začnite písať',
  'label.start_date': 'Dátum začiatku',
  'label.select': 'Vybrať',
  'label.select_async': 'Začnite písať...',
  'label.select_your_operating_authority': 'Vyberte svojho Autorizovaného prevádzkovateľa',
  'label.specify_category': 'Zadajte svoju kategóriu',
  'label.subcategory': 'Podkategória',
  'label.title': 'Titul',
  'label.username': 'Meno používateľa',
  'label.what_is_your_role': 'Aká je vaša rola v organizácii?',
  'label.where_have_you_completed': 'Miesto dokončenia',
  'label.yes': 'Áno',
  'label.your_changes_havent_been_saved': 'Tvoje zmeny sa neuložili. Údaje sa stratia.',
  'label.zip': 'PSČ',
  'label.adventurous_journey': 'Dobrodružná expedícia',
  'label.after_your_journey_describe': 'Popíš ako sa realizoval cieľ expedície a čo si sa naučil/a počas expedície.',
  'label.because_your_age_is_under_18': 'Vzhľadom na to, že máš menej ako 18 rokov, potrebujeme súhlas tvojho rodiča alebo poručníka. ',
  'label.before_you_head_to_journey': 'Pred pokračovaním v kvalifikačnej expedícii musíš najskôr splniť prípravnú a tréningovú časť.',
  'label.before_entering_new_level': 'Pred postúpením na ďalšiu úroveň potvrď, prosím, či sú tvoje osobné údaje stále aktuálne.',
  'label.bring_required_amount_to_your_award_leader': 'Prines požadovanú čiastku svojmu Vedúcemu programu alebo Koordinátorovi programu v Miestnom centre.',
  'label.do_you_have_any_other_level': 'Máš akékoľvek predchádzajúce úrovne DofE dokončené?',
  'label.do_you_know_who_is_your_award_leader': 'Vieš, kto je tvoj Vedúci programu?',
  'label.going_on_an_expedition': 'Expedícia ponúka dobrodružstvo, možnosti tímovej spolupráce a zároveň príležitosť prebrať za seba zodpovednosť.',
  'label.going_on_residential_gives_chance': 'Rezidenčný projekt ponúka možnosti spolupráce s ľuďmi z iného sociálneho pozadia a budovanie sebadôvery vďaka potrebe sa vynájsť v novom prostredí.',
  'label.i_confirm_that_i_meet': 'Potvrdzujem, že som splnil/-a požiadavky Národnej kancelárie.',
  'label.i_agree_to_volunteer_code': "Súhlasím s Kódexom správania dobrovoľníka. Ďalšie informácie sa zobrazia po kliknutí <a href='{url}' target='_blank'>sem</a>.",
  'label.i_have_read_the_terms_and_conditions': 'Prečítal/-a som si Podmienky a požiadavky a súhlasím s nimi.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Súhlas odovzdám svojmu Vedúcemu programu neskôr',
  'label.if_you_are_from_orphanage': 'Napríklad ak sa tvoje Miestne centrum rozhodlo zaplatiť za teba.',
  'label.here_you_can_add_activity': 'Na tomto mieste môžeš zadať ďalšiu aktivitu v rámci prípravy a tréningu.',
  'label.how_do_you_want_to_apply': 'Spôsob žiadosti:',
  'label.my_parent_consent_has_been_already_given': 'Súhlas rodiča/poručníka som už odovzdal svojmu Vedúcemu programu.',
  'label.my_parent_will_confirm_consent_by_email': 'Rodič/poručník odošle svoj súhlas e-mailom.',
  'label.major_activity_means_that_you_have_to_spent': 'Pri plnení hlavnej aktivity jej musíš venovať dvakrát toľko času, ako ostatným aktivitám.',
  'label.not_sure_about_your_auth': 'Nie ste si si istí, u ktorého poskytovateľa DofE by ste sa mali zaregistrovať? Kontaktujte nás na info@dofe.sk.',
  'label.page_not_found': '404 - Stránka nenájdená.',
  'label.please_fill_in_the_following': 'Zadaj pre autorizačný kontakt/držiteľa licencie vo svojej organizácii tieto údaje:',
  'label.register_a_new_account_as': 'Registrovať nové konto ako:',
  'label.residential_project': 'Rezidenčný projekt',
  'label.select_your_award_unit': 'Vyber svoje Miestne centrum',
  'label.the_expedition_can_be_faraway': 'Expedícia môže byť od tvojho domova veľmi vzdialená, ale aj blízka (podľa tvojich preferencií) a spôsobov, akými ju môžeš absolvovať, je nespočetne.',
  'label.to_log_your_process_on_orb': 'Na zaznamenanie svojho postupu do Online Účastníckej knižky (ORB) potrebuješ osobné konto pre ORB.<br />Sem zadaj svoje údaje.',
  'label.waiting_for_assessment': 'Čaká na hodnotenie',
  'label.waiting_for_sign_off': 'Čaká na schválenie Vedúcim programu.',
  'label.we_have_sent_you_an_email': 'Poslali sme e-mail s prepojením na aktiváciu.',
  'label.what_level_of_the_award': 'Pre akú úroveň DofE sa registruješ?',
  'label.you_are_now_registering_as_participant': 'Momentálne sa registruješ ako účastník DofE.',
  'label.you_are_now_registering_as_award_unit': 'Momentálne sa registrujete ako Miestne centrum.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Ako účastník programu DofE dávam svoj súhlas na použitie mojich obrázkov a fotografií na propagačné účely programu DofE.',
  'label.you_can_send_activity_for_approval': 'Teraz môžeš poslať svoju aktivitu hodnotiteľovi na schválenie.',
  'label.you_can_send_activity_for_leader': 'Teraz môžeš poslať svoju aktivitu Vedúcemu programu na schválenie.',
  'label.you_can_send_residential_project_to_leader': 'Teraz môžeš poslať svoj rezidenčný projekt Vedúcemu programu na schválenie.',
  'label.you_have_finished_now_send_to_approval': 'Hotovo. Teraz to môžeš poslať Vedúcemu na schválenie. Nižšie je možné pridať osobnú poznámku.',
  'label.preparation_and_training': 'Príprava a tréning',
  'label.you_will_be_redirected_to_the_payment': 'Budeš presmerovaný/-á na platobnú stránku, kde môžeš úhradu vykonať prostredníctvom kreditnej alebo debetnej karty.',
  'label.you_will_be_the_first_award_leader': 'Budete prvým Vedúcim programu vo svojej organizácii. Budete mať práva pridávať ďalších Vedúcich programu, účastníkov a spravovať proces spracovania údajov DofE v systéme Online Účastníckej knižky (ORB).',
  'label.youll_receive_a_notification': 'Po schválení registrácie Vedúcim programu dostaneš oznámenie. <a>Tu</a> sa môžeš prihlásiť do Online Účastníckej knižky Next Generation (kým Vedúci programu neschváli tvoju registráciu, budeš mať len obmedzené možnosti fungovania).',
  'label.your_parent_email': 'E-mail tvojho rodiča/poručníka',
  'label.your_parent_first_name': 'Krstné meno rodiča/poručníka',
  'label.your_parent_last_name': 'Priezvisko rodiča/poručníka',
  'label.your_report_approve_now_send_to_leader': 'Hodnotiteľ schválil tvoju správu. Teraz ju môžeš poslať na schválenie Vedúcemu programu. Nižšie je možné pridať osobnú poznámku.',
  'label.there_are_loads_of_exciting_possibilities': 'K dispozícii máš množstvo možností a ponúk. Stačí si vybrať niečo, čo ťa bude napĺňať.',
  'label.your_residential_project_has_been_setup': 'Tvoj rezidenčný projekt sa nastavil a odoslal Vedúcemu programu na schválenie.',
  'label.your_report_has_been_sent_assessor': 'Tvoja správa sa odoslala Hodnotiteľovi na schválenie.',
  'label.your_report_has_been_sent_leader': 'Tvoja správa sa odoslala Vedúcemu programu na schválenie.',
  'label.your_residential_project_is_complete': 'Tvoj rezidenčný projekt je dokončený.',
  'label.to_work_on_the_online': 'Ak chceš pracovať s Online Účastníckou knižkou, potrebuješ osobné konto pre ORB.',
  'label.we_will_send_you_an_email': 'Po schválení registrácie tvojho konta pre ORB ti odošleme e-mail.',
  'label.if_you_have_any_problems_or_doubts': 'Ak máš akékoľvek problémy alebo pochybnosti, obráť sa na svoje miestne centrum, ktoré ti poskytne viac informácií.',
  'label.are_you_sure_you_want_to_leave': 'Naozaj chceš zo stránky odísť? Tvoje údaje sa neuložia.',
  'label.no_logs_yet': 'Doteraz neboli pridané žiadne záznamy.<br />Pokús sa pridať svoj prvý záznam stlačením tlačidla Pridať záznam.',
  'label.menu': 'Ponuka',
  'notifications.award_unit_has_been_created': 'Miestne centrum bolo vytvorené',
  'notifications.authorization_code_is_not_valid': 'Autorizačný kód je neplatný',
  'notifications.email_has_been_confirmed': 'E-mailová adresa bola potvrdená',
  'notifications.leader_has_been_created': 'Vedúci bol vytvorený',
  'notifications.participant_has_been_created': 'Účastník bol vytvorený',
  'notifications.email_with_instructions_has_been_sent': 'Odoslal sa e-mail s pokynmi',
  'notifications.your_new_password_has_been_set': 'Tvoje nové heslo bolo nastavené',
  'notifications.success': 'Podarilo sa',
  'notifications.unknown_role': 'Neznáma rola',
  'notifications.waiting_for_approval': 'Čaká sa na schválenie',
  'notifications.activity_cannot_be_created': 'Aktivitu je možné vytvoriť až po schválení registrácie',
  'notifications.new_activity_has_been_added': 'Nová aktivita pridaná',
  'notifications.new_log_has_been_added': 'Nový záznam pridaný',
  'notifications.log_has_been_deleted': 'Záznam odstránený',
  'notifications.log_has_been_modified': 'Záznam bol upravený',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Dobrodružná expedícia sa dá vytvoriť až po schválení registrácie',
  'notifications.new_participant_event_has_been_added': 'Nová udalosť pre účastníka pridaná',
  'notifications.participant_event_has_been_completed': 'Udalosť účastníka dokončená',
  'notifications.training_and_practice_modified': 'Údaje tréningu a praxe boli upravené',
  'notifications.completion_residential_project_completed': 'Rezidenčný projekt bol dokončený',
  'notifications.new_residential_project_has_been_added': 'Nový rezidenčný projekt pridaný',
  'notifications.residential_project_cannot_be_created_until_approved': 'Rezidenčný projekt sa dá vytvoriť až po schválení registrácie',
  'notifications.already_assessed_sent': 'Žiadosť o schválenie Vedúcim programu odoslaná',
  'notifications.assessment_request_sent': 'Žiadosť o hodnotenie odoslaná',
  'notifications.leader_approval_sent': 'Žiadosť o schválenie Vedúcim programu odoslaná',
  'tabs.logs': 'Záznamy',
  'tabs.new': 'Nové',
  'tabs.overview': 'Prehľad',
  'tabs.report': 'Správa',
  'button.add_activity': 'Pridať aktivitu',
  'button.add_log': 'Pridať záznam',
  'button.continue_here': 'Tu pokračovať',
  'button.continue': 'Pokračovať',
  'button.continue_to_award': 'Pokračovať na DofE',
  'button.delete': 'Odstrániť',
  'button.edit': 'Upraviť',
  'button.edit_log': 'Upraviť záznam',
  'button.finish': 'Dokončiť',
  'button.forgot_your_password': 'Zabudol si heslo?',
  'button.i_already_have_assessment': 'Už mám hodnotenie',
  'button.leave_anyway': 'Opustiť aj v tomto prípade',
  'button.login': 'Prihlásiť sa',
  'button.no': 'Nie',
  'button.register': 'Registrovať sa',
  'button.send': 'Odoslať',
  'button.send_for_approval': 'Odoslať na schválenie',
  'button.setup': 'Nastaviť',
  'button.setup_residential': 'Nastaviť rezidenčný projekt',
  'button.stay': 'Ostať',
  'button.submit': 'Odoslať',
  'button.update': 'Aktualizovať',
  'button.yes': 'Áno',
  'errors.at_least_num_characters': 'Musí obsahovať minimálne tento počet znakov: {length}',
  'errors.do_not_match': 'Nezhoduje sa',
  'errors.include_at_least_one_number': 'Súčasťou musí byť minimálne jedna číslica',
  'errors.include_both_lower_and_upper_case': 'Súčasťou musia byť malé a veľké písmená',
  'errors.invalid_phone_format': 'Neplatný formát telefónneho čísla',
  'errors.invalid_email_address': 'Neplatný formát e-mailovej adresy',
  'errors.required_field': 'Požadované pole',
  'errors.must_be_at_least': 'Musí obsahovať minimálne tento počet znakov: {min}',
  'errors.must_be_no_more_than': 'Nesmie obsahovať viac ako tento počet znakov: {max}',
  'errors.must_be_an_integer': 'Musí byť celé číslo',
  'errors.must_contain_at_least': 'Musí obsahovať minimálne jedno číslo',
  'errors.must_include_at_least': 'Musí obsahovať minimálne jedno veľké písmeno',
  'errors.must_be_one_of': 'Musí byť jedna z týchto hodnôt: {enums}',
  'errors.you_must_be_younger_than': 'Musíš mať menej ako {years} rokov a {months} mesiacov na registráciu do DofE. Prosíme kontaktuj svoje Miestne centrum kvôli tomu.',
  'errors.you_must_be_older_than': 'Musíš mať viac ako {years} rokov a {months} mesiacov na registráciu do DofE. Prosíme kontaktuj svoje Miestne centrum kvôli tomu.',
  'errors.email_address_is_in_use_please_sign': 'E-mailová adresa sa už používa. Ak sa chceš registrovať na ďalšiu úroveň, prosíme prihlás sa do svojho konta.',
  'errors.email_address_is_in_use': 'E-mailová adresa sa už používa.',
  'errors.sorry_we_already_have_this_email': "Prepáč, ale už máme zaregistrované konto s týmto e-mailom. Ak chceš začať ďalšiu úroveň, <a href='/'>prihlás sa do konta</a> and vyber si možnosť Začať novú úroveň.",
  'wizard.authorising_contact': 'Kontakt na autorizáciu',
  'wizard.award_leader_contact': 'Kontakt na Vedúceho programu',
  'wizard.award_unit_details': 'Podrobnosti Miestneho centra',
  'wizard.contact_details': 'Kontaktné údaje',
  'wizard.contacts': 'Kontakty',
  'wizard.level': 'Úroveň DofE',
  'wizard.level_selection': 'Výber úrovne',
  'wizard.leader_details': 'Podrobnosti Vedúceho programu',
  'wizard.nominated_award_leader': 'Nominovaný Vedúci programu',
  'wizard.orb_account': 'Konto ORB',
  'wizard.parent_consent': 'Súhlas rodiča',
  'wizard.participant_details': 'Podrobnosti účastníka',
  'wizard.profile': 'Profil',
  'wizard.payment': 'Platba',
  'wizard.select_award_unit': 'Vybrať Miestne centrum',
  'wizard.unit_details': 'Podrobnosti Miestneho centra',
  'wizard.welcome': 'Vitajte',
  'wizard.your_details': 'Vaše detaily',
  'awardUnit.do_you_want_to_create': 'Chcete vytvoriť nové Miestne centrum?',
  'parent.you_can_download_the_consent_here': 'Ak ešte nemáš formulár rodičovského súhlasu, môžeš si ho stiahnuť na tomto mieste. Požiadaj rodiča/poručníka o jeho podpísanie a odovzdaj ho svojmu Vedúcemu programu.',
  'footer.copyright': "&copy; Copyright The Duke of Edinburgh's International Award 2017",
  'registration_participant.required_award_payment': 'Vyžaduje sa platba za DofE',
  'registration_participant.pay_online_here': 'Zaplať online a svoje ID transakcie získaš tu.',
  'dashboard.activity_log_time': '{hours}h {minutes}min ',
  'moduleTitle.award_completed': 'DofE je dokončené!',
  'notifications.award_approval_request_sent_to_leader': 'Vedúcemu programu bola odoslaná žiadosť o schválenie DofE',
  'notifications.new_participant_event_has_been_completed': 'Nová udalosť pre účastníka dokončená',
  'notifications.preparation_and_training_approval_sent': 'Schválenie prípravy a tréningu odoslané',
  'notifications.reparation_and_training_completed': 'Príprava a tréning dokončené',
  'notifications.your_profile_photo_has_been_edited': 'Fotografia v tvojom profile bola upravená',
  'notifications.your_profile_has_been_edited': 'Tvoj profil bol upravený',
  'notifications.new_level_has_started': 'Začala nová úroveň',
  'notifications.activity_has_been_edited': 'Aktivita bola upravená',
  'notifications.you_have_been_logged_out': 'Odhlasuje sa...',
  'notifications.logging_out': 'Prebehlo odhlásenie',
  'label.you_can_send_award_to_leader': 'Svoje DofE môžeš odoslať Vedúcemu programu na schválenie',
  'label.you_have_completed_all_sections_of_your_award': 'Dokončil/-a si všetky oblasti svojho DofE. Teraz ho môžeš odoslať Vedúcemu programu na schválenie. Nižšie je možné pridať osobnú poznámku.',
  'label.you_have_now_completed_your_award': 'Dokončil/-a si svoje DofE na úrovni {level}. Chceš začať ďalšiu úroveň?',
  'label.congratulation_your_award_has_been_approved': 'Gratulujeme. Tvoje DofE na úrovni {level} bolo schválené. <br /> Ak chceš, môžeš začať novú úroveň.',
  'moduleTitle.settings': 'Nastavenie',
  'moduleTitle.edit_activity': 'Upraviť aktivitu',
  'moduleTitle.select_your_major_activity': 'Vybrať hlavnú aktivitu',
  'label.settings': 'Nastavenie',
  'label.major_activity_means_that_you_will': 'Hlavná aktivita znamená, že budeš musieť touto aktivitou stráviť dlhší čas ako v iných oblastiach. Na Zlatej a Striebornej úrovni vyžaduje dodatočných 6 mesiacov a na Bronzovej úrovni dodatočné 3 mesiace.',
  'label.notifications': 'Oznámenia',
  'label.my_award': 'Moje DofE',
  'label.physical_recreation': 'Športová aktivita',
  'label.skill': 'Rozvoj talentu',
  'label.service': 'Dobrovoľníctvo',
  'label.my_parent_will_complete_and_sign_form': 'Môj rodič/poručník dokončí a podpíše formulár na súhlas rodiča/poručníka',
  'label.please_print_it_tak_it_to_your_parent': 'Formulár vytlač, odovzdaj rodičovi/poručníkovi na podpísanie a odovzdaj svojmu Vedúcemu programu.',
  'label.change_password': 'Zmeniť heslo',
  'label.change_major_activity': 'Zmeniť hlavnú aktivitu',
  'title.change_password': 'Zmena hesla',
  'label.old_again': 'Staré heslo',
  'label.new_password': 'Nové heslo',
  'label.new_password_again': 'Zopakovať nové heslo',
  'errors.passwords_dont_match': 'Heslá nie sú zhodné',
  'errors.more_than': 'Viac ako {limit} ',
  'button.parent_guardian_consent_pdf': 'Suhlas_rodica/porucnika.pdf',
  'button.send_award_for_approval': 'Odoslať DofE na schválenie',
  'button.send_report': 'Odoslať správu',
  'button.terms_and_conditions': 'Medzinárodné podmienky a požiadavky',
  'button.privacy_policy': 'Politika ochrany osobných údajov',
  'button.save': 'Uložiť',
  'button.start_new_level': 'Začať novú úroveň',
  'button.change_password': 'Zmeniť heslo',
  'button.edit_activity': 'Upraviť aktivitu',
  'moduleTitle.file_upload': 'Nahratie súboru',
  'label.add_file': 'Pridať súbor',
  'label.description': 'Popis',
  'label.waiting_for_office_sign_off': 'Čaká sa na schválenie Národnou kanceláriou',
  'notifications.file_has_been_uploaded': 'Súbor sa nahral',
  'tabs.files': 'Súbory',
  'button.upload': 'Nahrať',
  'button.upload_file': 'Nahrať súbor',
  'button.add_file': 'Pridať súbor',
  'button.this_activity_has_no_assessor': 'Táto aktivita nemá hodnotiteľa. Musíš nastaviť podrobnosti o hodnotiteľovi pred jej odoslaním na schválenie.',
  'label.i_want_to_register_my_award': 'Chcem svoje Miestne centrum zaregistrovať ako Nezávislé miestne centrum.',
  'label.select_sub_operating_authority': 'Výber Autorizovaného prevádzkovateľa na nižšej úrovni',
  'label.your_must_first_setup_some_activity': 'Najskôr musíš nastaviť nejakú aktivitu',
  'label.you_cant_change_your_major_activity': 'Hlavnú aktivitu nemôžeš zmeniť. Hlavná aktivita sa už ukončila.',
  'label.s_specific': '<b>S-Specific (Špecifický): Tvoj cieľ nemôžeš popísať zoširoka. Namiesto ‘Chcem byť lepší v hraní na husle’, môžeš povedať ‘Chcem sa naučiť zahrať na husliach stupnicu F dur’.',
  'label.m_measurable': '<b>M-Measurable (Merateľný): Je potrebné určiť hranicu, ktorá bude znamenať dosiahnutie tvojho cieľa. Namiesto toho, aby sa cieľ zadefinoval/a ako ‘Chcem pomôcť komunite’, môžeš povedať, ‘Chcem pomôcť 100 ľuďom, ktorí navštívia vývarovne, aby mali prístup aspoň k jednému teplému jedlu denne.’ Takýmto spôsobom môže byť cieľ overený.',
  'label.a_achievable': '<b>A-Achievable (Dosiahnuteľný): Tvojím cieľom by malo byť niečo, čo môžeš dosiahnuť počas zapojenia do špecifickej dĺžky tebou zvolenej úrovne DofE. Namiesto všeobecného cieľu ‘Chcem ukončiť svetovú chudobu’, bude najlepšie nastaviť praktickejší cieľ ako napr. ‘Chcem vyzbierať a poslať 2 000 € na kurzy anglického jazyka pre 20 detí z detských domovov na Slovensku, aby sa mohli lepšie uplatniť na trhu práce.’',
  'label.r_realistic': '<b>R-Relevant (Relevantný): Tvojím cieľom by malo byť niečo, čo je relevantné pre teba alebo v rámci dobrovoľníctva pre tvoje okolie, mesto alebo krajinu. Vo všetkých oblastiach DofE si musíš odpovedať, prečo je pre teba cieľ dôležitý a ako ti pomáha dosiahnuť tvoje dlhodobé ciele. Napr. prečo by si v rámci rozvoja talentu mal hrať na gitare v prípade, že chceš ísť študovať medicínu do zahraničia. V rámci dobrovoľníctva by si mal/a identifikovať reálny problém v tvojom okolí a snažiť sa ho cez dobrovoľníctvo vyriešiť. Napr. poznáš na škole študentov s telesným postihnutím, ktorí kvôli zlému prístupu v starej budove nemôžu navštevovať niektoré hodiny a ty pomôžeš vyzbierať nutné financie na úpravu budovy.',
  'label.t_timely': '<b>T- Time-Bound (Časovo ohraničnený): Tvoj cieľ by mal obsahovať informáciu o tom, dokedy bude cieľ naplnený. Tvoj cieľ by mohol byť, ‘Do 3 mesiacov zvládnem na husliach zahrať stupnicu F dur.’',
  'label.you_can_upload_here_any_files': 'Tu môžeš nahrať akékoľvek súbory (10mb a menej), ktoré chceš zdieľať s Vedúcim programu.',
  'moduleTitle.login_change': 'Zmena prihlasovacích údajov',
  'notifications.adventurous_journey_modified': 'Dobrodružná expedícia sa zmenila',
  'tabs.sections': 'Sekcie',
  'label.change_email': 'Zmeniť e-mail',
  'title.change_email': 'Zmena e-mailu',
  'label.new_email': 'Nový e-mail',
  'label.new_email_again': 'Znova zadať nový e-mail',
  'errors.emails_dont_match': 'E-mailové adresy sa nezhodujú',
  'button.change_email': 'Zmeniť e-mail',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Do tvojej doručenej pošty bol odoslaný e-mail s pokynmi',
  'global.dofe_name': 'Medzinárodná cena ',
  'global.or': 'alebo',
  'route.landing_page': 'Domov',
  'route.dashboard': 'Aplikácia',
  'moduleTitle.notifications': 'Notifikácie',
  'moduleTitle.no_notifications': 'Žiadne notifikácie',
  'moduleTitle.new_notifications': 'Nové notifikácie',
  'moduleTitle.older_notifications': 'Staršie notifikácie',
  'moduleTitle.user_guide': 'Užívateľská príručka',
  'label.user_guide': 'Užívateľská príručka',
  'notifications.your_password_has_been_changed': 'Heslo bolo zmenené',
  'label.country': 'Krajina',
  'label.on_your_smartphone': 'Na smartfóne',
  'label.on_the_web': 'Na webe',
  'label.orb_online': 'ORB online',
  'label.language': 'Jazyk',
  'moduleTitle.participant_login': 'Prihlásenie',
  'label.for_ios': 'pre iOS',
  'label.for_android': 'pre Android',
  'button.login_as_award_staff': 'Prihlásiť sa ako správca',
  'errors.leader_doesnt_exist': 'Vedúci neexistuje',
  'global.loading': 'Načítavam',
  'moduleTitle.award_staff_login': 'Prihlásenie vedúceho',
  'formTitle.residential_project_details': 'Podrobnosti rezidenčného projektu',
  'label.you_can_also_download_participant': 'Získajte prístup do Online Účastníckej knižky (ORB) s našimi novými aplikáciami',
  'label.you_can_also_download_leader': 'Získajte prístup do Online Účastníckej knižky (ORB) s našimi novými aplikáciami',
  'notifications.this_role_is_not': 'Nepodporovaná rola',
  'notifications.residential_project_has_been_updated': 'Rezidenčný projekt upravený',
  'tabs.participant': 'Účastník',
  'tabs.award_staff': 'Vedúci',
  'moduleTitle.edit_residential_project': 'Upraviť rezidenčný projekt',
  'button.residential_project': 'Upraviť rezidenčný projekt',
  'notifications.your_login_email_has_been_changed': 'Váš prihlasovací email bol zmenený',
  'meta.dofe_name': 'Medzinárodná cena vojvodu z Edinburghu',
  'notifications.unknown_role_leader': 'Neznáma rola - použite prihlasovanie pre Vedúcich programu',
  'notifications.unknown_role_participant': 'Neznáma rola - použite prihlasovanie pre účastníkov',
  'label.user_guide_web_participant': 'Užívateľská príručka pre účastníka - web',
  'label.user_guide_app_participant': 'Užívateľská príručka pre účastníka - aplikácia',
  'label.note_for_supervisor': 'Poznámka pre školiteľa',
  'label.before_submitting_your_aj': 'Pred odoslaním expedície Vedúcemu potrebuješ schváliť expedíciu od {role}. Nižšie je možné pridať osobnú poznámku.',
  'button.back_to_home': 'Naspäť domov',
  'moduleTitle.assessor_approval': '{role} Schválenie',
  'label.this_aj_has_no_assessor': 'Tejto expedícii nie je pridelený žiaden {role}. Musíte aktualizovať detaili pred odoslaním na schválenie.',
  'route.not_found': 'Nenájdené',
  'notifications.are_you_sure': 'Ste si istí?',
  'button.cancel': 'Zrušiť',
  'label.add_document': 'Pridať dokument',
  'errors.there_are_currently_no_details_for_your': 'Tvoj {role} nemá vyplnené žiadne informácie. Pred odoslaním tvojej aktivity na zhodnotenie, prosíme doplň chýbajúce údaje',
  'moduleTitle.missing_data': 'Chýbajúce údaje',
  'label.to_send_assessment_request': 'Ak chceš odoslať elektronickú žiadosť o hodnotenie, prosíme vyplň email pre: {role}',
  'label.pending_changes': 'Čaká na zmeny...',
  'label.some_fields_require': 'Niektoré položky vyžadujú pozornosť',
  'roles.assessor': 'Hodnotiteľ',
  'roles.supervisor': 'Školiteľ',
  'pageTitle.register_participant': 'Registrovať účastníka',
  'moduleTitle.revise_message': 'Správa k vráteniu',
  'moduleTitle.payment_for_level': 'Platba za {awardLevel}',
  'moduleTitle.payment': 'Úhrada poplatkov za registráciu účastníkov',
  'moduleTitle.we_have_sent_you_payment_link': 'Odoslali sme vám e-mail s prepojením na platobnú bránu.',
  'label.required_award_payment': 'Požadovaná platba',
  'label.payment_fees': 'Dodatočný členský príspevok za účastníka',
  'label.payment_method': 'Spôsob platby',
  'label.you_will_type_trans_id': 'Budete požiadaní, aby ste zadali ID svojej transakcie.',
  'label.any_level_previously': 'Akákoľvek úroveň, ktorá už bola dosiahnutá',
  'label.registering_for_level': 'Registrácia pre úroveň',
  'notification.payment_link_expired': 'Prepojenie na platbu expirovalo',
  'button.pay': 'Platiť',
  'label.registration_updated': 'Registrácia sa aktualizovala, teraz môžete stránku zavrieť.',
  'label.award_leader_receive_payment': 'Vedúci programu dostane informácie o platbe.',
  'errors.end_date_after': 'Dátum ukončenia musí nasledovať po dátume spustenia',
  'button.back': 'Naspäť',
  'button.edit_info': 'Upraviť informácie',
  'moduleTitle.level_detail': 'Podrobnosti o úrovni',
  'label.payment_methods': 'Metódy platby',
  'label.address': 'Adresa',
  'note.review_filled_participant': 'Prosím, pozrite si údaje, ktoré vyplnil účastník. Ak nájdete nesprávne, môžete ich upraviť.',
  'moduleTitle.payment_successful': 'Platba za dodatočný členský príspevok za účastníka bola úspešná',
  'button.proceed_to_login': 'Pokračujte na možnosť prihlásenia',
  'label.add_additional_activity': 'Pridať ďalšiu aktivitu',
  'moduleTitle.welcome_to_orb': 'Vitajte v Online účastníckej knižke',
  'empty_dashboard.not_approved': 'Tento nástroj vám pomôže zaznamenať váš postup počas DofE. Váš profil však ešte nebol schválený Vedúcim programu. Svoju prvú aktivitu budete môcť začať vytvárať až po schválení.',
  'empty_dashboard.approved_1': 'Tento nástroj vám pomôže zaznamenať váš postup počas DofE.',
  'empty_dashboard.approved_2': 'Najskôr musíte nastaviť svoju aktivitu. Začnite kliknutím na niektorú z aktivít naľavo. Ak potrebujete pomoc s nastavením aktivity, obráťte sa na Vedúceho programu.',
  'label.discuss_activity_leader': 'Ak si vyberáte viac aktivít, skonzultujte ich s Vedúcim programu.',
  'label.cannot_add_activity': 'V rámci tejto kategórie môžete pridať maximálne 3 aktivity. Skonzultujte to s Vedúcim programu.',
  'button.ok': 'OK',
  'label.payment_was_canceled': 'Používateľ zrušil platbu',
  'label.problem_with_payment': 'Nastal problém s procesovaním tvojej platby. Prosíme kontaktuj Národnú kanceláriu DofE.',
  'pageTitle.register_leader': 'Registrovať Vedúceho',
  'pageTitle.registration_complete': 'Registrácia sa dokončila',
  'label.payment_link_expired_or_paid': 'Platba už bola vykonaná ALEBO prepojenie na úhradu expirovalo.',
  'label.contact_nao_assistance': 'Ak potrebujete pomoc, obráťte sa na Národnú kanceláriu DofE.',
  'label.send_required_amount_to_your_award_leader': 'Požadované množstvo odošlite svojmu Vedúcemu programu alebo koordinátorovi DofE vo vašom centre.',
  'label.fee_can_be_paid': 'Príspevok je možné zaplatiť on-line pomocou VISA, Master Card alebo kreditných kariet.',
  'notifications.login_failed_right_tab': 'Prihlásenie nebolo úspešné. Overte, či ste na správnej karte (Účastník/Zamestnanec DofE)',
  'label.i_have_read_privacy_policy': 'Prečítal/-a som si zásady ochrany osobných údajov a súhlasím s nimi.',
  'errors.invalid_date_format': 'Neplatný formát dátumu.',
  'label.no_privacy_policy': 'Pokračujte kliknutím na tlačidlo dokončenia.',
  'label.status': 'Stav',
  'moduleTitle.attached_with_observation': 'Priložené s pozorovaním',
  'moduleTitle.revise_message_rp': 'Vedúci programu revidoval váš rezidenčný projekt.',
  'file.activity_section_summary': '{section}-oblasť-správa',
  'label.download_section_summary': 'Stiahnuť súhrn oblasti',
  'label.award_summary': 'Súhrn postupu v DofE',
  'btn.download_summary_for_assessor': 'Stiahnuť súhrn pre hodnotiteľa',
  'label.first_activity_started': 'Prvá aktivita bola spustená',
  'label.hours_completed_required': 'Dokončené/požadované hodiny',
  'label.weeks_completed_required': 'Dokončené/požadované týždne',
  back_to_home: 'Naspäť na domovskú stránku',
  'label.activity_rejected_click': 'Vedúci programu zamietol vašu aktivitu. Kliknite, ak chcete',
  'button.more_information': 'ďalšie informácie',
  'label.attached_file': 'Priložený súbor',
  'moduleTitle.journey_details': 'Podrobnosti o expedícii',
  'tabs.activity': 'Aktivita',
  'label.confirm_email': 'Potvrdzujúci email',
  'label.aj_rejected_click': 'Tvoja expedícia bola zamietnutá tvojím Vedúcim. Klikni pre ',
  'label.verifying_payment': 'Overuje platbu',
  'button.finish_and_pay': 'Dokončiť a zaplatiť',
  'label.payment_not_successful_text': 'Keďže sa ti nepodarilo uskutočniť platbu za príspevok, je potrebné ju uskutočniť teraz',
  'label.payment_not_completed': 'Platba nedokončená',
  'button.pay_now': 'Zaplatiť ihneď',
  'label.registration_pending_parental_consent': 'Tvoja registrácia čaká na súhlas rodiča / poručníka',
  'button.edit_observation': 'Upraviť pozorovania',
  'moduleTitle.qualifying': 'Kvalifikačná',
  'moduleTitle.practice': 'Prax',
  'label.first_log_entry': 'Zadanie prvého záznamu',
  'label.first_log_entry_date': 'Dátum zadania prvého záznamu',
  'label.last_log_entry': 'Zadanie posledného záznamu',
  'label.last_log_entry_date': 'Dátum zadania posledného záznamu',
  'label.you_can_send_journey_report_for_approval': 'Svoju správu z expedície {journey} môžete odoslať na schválenie.',
  'button.edit_and_resend_report': 'Upraviť správu a znova odoslať',
  'label.your_journey_is_complete': 'Vaša expedícia {journeyType} je dokončená.',
  'button.add_additional_journey': 'Pridať ďalšiu expedíciu',
  'moduleTitle.edit_journey': 'Upraviť expedíciu',
  'notifications.assessment_sent': 'Hodnotenie sa odoslalo',
  'notifications.file_is_too_big': 'Súbor sa nepodarilo nahrať. Limit veľkosti súboru je 10mb.',
  'notifications.authorization_code_has_expired': 'Platnosť autorizačného kódu z bezpečnostných príčin vypršala. Požiadajte o nový kód',
  'route.confirm_email': 'Potvrdiť e-mail',
  'label.assessor_needs_account': 'Ak chcete upravovať online účastnícku knižku (ORB), potrebujete vlastné konto pre ORB. <br/>Svoje podrobnosti zadajte sem',
  'label.company_name': 'Názov spoločnosti',
  'label.secondary_email_again': 'Potvrdiť sekundárny e-mail',
  'label.how_many_years': 'Koľko rokov/mesiacov?',
  'label.no_company_leave_empty': 'Ak nepracujete pre spoločnosť, ponechajte toto pole prázdne',
  'label.secondary_phone_number': 'Sekundárne telefónne číslo',
  'label.secondary_phone_type': 'Typ sekundárneho telefónu',
  'label.wwc_application_number': 'Číslo ochrany dieťaťa',
  'label.wwc_expiration_date': 'Dátum uplynutia platnosti ochrany dieťaťa',
  'label.you_are_now_registering_as_assessor': 'Registrujete sa ako hodnotiteľ',
  'label.you_have_finished_aj_now_send_to_approval': 'Vaša dobrodružná expedícia sa ukončila. Môžete ju teraz odoslať svojmu hodnotiteľovi na schválenie. Nižšie môžete pridať vlastnú poznámku.',
  'label.your_experience': 'Vaša skúsenosť',
  'label.your_qualification': 'Vaša kvalifikácia',
  'notifications.waiting_for_assessor_approval': 'Čaká sa na schválenie hodnotiteľom',
  'button.resend_assessment_request': 'Znova odoslať žiadosť o hodnotenie',
  'errors.emails_must_be_different': 'Sekundárny e-mail sa musí odlišovať od primárneho',
  'moduleTitle.company_details': 'Údaje spoločnosti',
  'notifications.already_resent_assessment_request': 'Žiadosť o hodnotenie ste už odoslali',
  'route.assessor_dashboard': 'Tabuľa hodnotiteľa',
  'pageTitle.register_assessor': 'Zaregistrovať hodnotiteľa',
  'wizard.assessor_details': 'Údaje hodnotiteľa',
  'wizard.assessor_experience': 'Skúsenosť hodnotiteľa',
  'wizard.personal_details': 'Osobné údaje',
  'button.sign_off': 'Odhlásiť sa',
  'button.sign_off_dashed': 'Odhlásiť sa',
  'moduleTitle.sign_off': 'Odhlásenie',
  'label.certify_participant_met_reqs': 'Ako hodnotiteľ tejto aktivity potvrdzujem, že účastník splnil požiadavky.',
  'label.assessor_report': 'Hlásenie hodnotiteľa',
  'label.content_update': 'Čakajte. Aktualizuje sa obsah.',
  'label.comment_on_participant_improvement': 'Prosím, pridajte komentár týkajúci sa zlepšenia a predpokladaného výkonu účastníka',
  'note.edit_participant_review': 'Ak chcete niektoré údaje opraviť, kliknite na tlačidlo Upraviť.',
  'errors.min_age': 'Minimálny vek:  {age}',
  'notifications.assessor_link_expired': 'Prepojenie na registráciu hodnotiteľa vypršalo',
  'label.secondary_email': 'Sekundárny e-mail',
  'moduleTitle.review_participant_info': 'Revidovať údaje účastníka',
  'label.loading_payment_gateway': 'Platobná brána sa načítava',
  'label.consent_given_login_as_child': 'Súhlas už bol odoslaný. Prihláste sa ako dieťa.',
  'notifications.only_one_qualification_journey_per_award': 'Ako súčasť DofE je možné nastaviť len jednu kvalifikačnú expedíciu',
  'label.registration_fees_participant': 'Platba Dodatočného členského príspevku na účastníka - {name} (#{id})',
  'moduleTitle.leader_details': 'Podrobnosti o Vedúcom DofE',
  'label.leader_name': 'Meno Vedúceho DofE',
  'label.leader_phone': 'Telefón Vedúceho DofE',
  'label.leader_email': 'E-mail Vedúceho DofE',
  'moduleTitle.au_details': 'Údaje Miestneho centra',
  'label.au_name': 'Názov Miestneho centra',
  'label.assessor_guidelines': 'Pokyny',
  'label.assessor_cond_req': 'Kľúčové podmienky a požiadavky',
  'label.assessor_ref_handbook': 'Odkaz na príručku k DofE',
  'label.assessor_ref_online_modules': 'Odkaz na moduly vzdelávania online',
  'label.participant_has_no_aj_report': 'Účastníci ešte neodoslali správu.',
  'moduleTitle.participant_details': 'Údaje účastníkov',
  'label.participants_has_no_logs': 'Účastníci ešte nemajú denníky.',
  'label.location_type': 'Typ miesta',
  'label.activity_ready_for_signoff': 'Táto aktivita je pripravená na schválenie',
  'label.activities': 'Aktivity',
  'label.choose_how_you_want_to_login': 'Vyberte spôsob prihlásenia:',
  'roles.leader': 'Vedúci',
  'roles.award_verifier': 'Overovateľ DofE',
  'roles.coordinator': 'Koordinátor',
  'roles.aj_assessor': 'Hodnotiteľ dobrodružnej expedície',
  'roles.aj_supervisor': 'Supervízor dobrodružnej expedície',
  'roles.instructor': 'Inštruktor',
  'roles.nao_staff': 'Zamestnanec Národnej kancelárie DofE',
  'roles.super_user': 'Používateľ s vyššími právomocami',
  'roles.user': 'Používateľ',
  'roles.viewer': 'Používateľ s právomocami na zobrazenie',
  'roles.authorizing_contact': 'Autorizačný kontakt',
  'roles.if_staff_superuser': 'Používateľ s vyššími právomocami – zamestnanec nadácie DofE',
  'roles.if_staff_statistical_user': 'IF Statistical User',
  'roles.if_staff_viewer': 'Používateľ s právomocami na zobrazenie – zamestnanec nadácie DofE ',
  'roles.aj_instructor': 'Inštruktor dobrodružnej expedície',
  'label.if_you_have_questions_au': 'Ak máte akékoľvek otázky týkajúce sa vašej registrácie, obráťte sa na svoje Miestne centrum.',
  'label.we_will_send_you_an_email_leader': 'Po schválení registrácie vášho konta pre online účastnícku knižku vám pošleme e-mail.',
  'moduleTitle.rejecting_assessor_invitation': 'Odmietnutie pozvania na účasť v roli hodnotiteľa',
  'notifications.assessor_invitation_rejected': 'Pozvanie na účasť v roli hodnotiteľa bolo zamietnuté',
  'moduleTitle.participants_list_is_empty': 'Zoznam účastníkov je prázdny',
  'label.note_from_participant': 'Poznámka od účastníka',
  'label.you_can_send_aj_to_leader': 'Svoju dobrodručnú expedíciu môžete odoslať na schválenie Vedúcemu.',
  'button.save_report': 'Uložiť správu',
  'label.this_activity_has_no_assessor': 'Táto aktivita nemá hodnotiteľa. Pred jej odoslaním na schválenie musíte nastaviť podrobnosti o hodnotiteľoch.',
  'label.activity_rejected_click_by_assessor': 'Vaša aktivita bola zamietnutá hodnotiteľom. Kliknite s cieľom: ',
  'button.reject': 'Zamietnuť',
  'button.reject_invitation': 'Zamietnuť pozvanie',
  'label.reason': 'Príčina',
  'label.accept_invitation_and_continue': 'Prijať pozvanie a pokračovať',
  'pageTitle.registration_reject': 'Zamietnutie registrácie',
  'errors.you_must_be_older_than_register_for_leader': 'Ak sa chcete zaregistrovať ako Vedúci DofE, musíte mať viac ako tento počet rokov {years} a mesiacov {months}.',
  'label.your_report_approve_now_send_to_leader_without_note': 'Vaša správa bola schválená. Teraz ju môžete odoslať na schválenie Vedúcemu DofE.',
  'button.stop_assessing_this_activity': 'ZASTAVIŤ HODNOTENIE TEJTO AKTIVITY',
  'button.confirm': 'Potvrdiť',
  'moduleTitle.are_you_sure': 'Ste si istí?',
  'label.content_restore': 'Obnovenie súhlasu',
  'button.stop_editing': 'Zastaviť upravovanie',
  'notifications.activity_has_been_rejected': 'Aktivita bola zamietnutá',
  'notifications.aj_has_been_rejected': 'Dobrodružná expedícia bola zamietnutá',
  'notifications.rp_has_been_rejected': 'Rezidenčný projekt bol zamietnutý',
  'moduleTitle.additional_files': 'Dodatočné súbory',
  'moduleTitle.no_additional_files': 'Dodatočné súbory',
  'moduleTitle.stop_assessing_section': 'Zastaviť hodnotenie sekcie',
  'label.show_security_and_refund_policy': 'Zobraziť politiku zabezpečenia a refundácií',
  'moduleTitle.security_and_refund_policy': 'Politika zabezpečenia a refundácií',
  'label.fees_payment': 'Platby',
  'label.redund_policy': 'Politika refundácií',
  'label.security_policy': 'Politika zabezpečenia',
  'label.leave_blank': 'Ponechať prázdne',
  'label.frequently_asked_questions': 'Najčastejšie otázky',
  'label.language_selection_is_disabled_for_iac': 'Pre centrá IAC je vypnutá možnosť výberu jazyka',
  'errors.min_nights_required': 'Požaduje sa minimálne tento počet nocí: {nights}',
  'label.completion_date': 'Dátum dokončenia',
  'label.you_are_offline': 'Ste offline. Zmeny vykonané teraz nemusia byť uložené.',
  'errors.start_date_after_award_start': 'Dátum začiatku nemôže byť pred začatím súčasnej úrovne programu.',
  'label.participants': 'Účastníci',
  'label.marketing_from_iaf': 'Prihlásiť sa na príjem noviniek z Nadácie DofE v Londýne.',
  'label.marketing_from_oa': 'Prihlásiť sa na príjem noviniek od Autorizovaného prevádzkovateľa',
  'label.marketing_from_nao': 'Prihlásiť sa na príjem noviniek z Národnej kancelárie.',
  'label.select_iac': 'Vybrať Nezávislé centrum programu',
  'label.you_will_be_redirected_to_the_paypal_payment': 'Kliknutím na tlačidlo "Zaplatiť" vyššie zaplatíš online pomocou kreditnej karty Visa, MasterCard, debetnej karty Visa alebo PayPal účtu.',
  'notifications.report_has_been_sent': 'Správa bola odoslaná',
  'label.processing_paypal_payment': 'Spracovanie platby PayPal',
  'label.loading_paypal_gateway': 'Načítava sa brána PayPal',
  'label.payment_failed': 'Platba zlyhala',
  'label.payment_has_been_cancelled': 'Platba bola zrušená alebo zlyhala',
  'roles.naa_oa_staff': 'Zamestnanci Národnej kancelárie',
  'label.download_report_and_upload_signed_version': 'Stiahnuť správu a nahrať podpísanú verziu',
  'button.download_summary_for_assessor': 'Stiahnuť súhrn pre hodnotiteľa',
  'label.pay_online_mastercard': 'Platba online',
  'label.pay_online_paypal': 'Platba online',
  'notifications.authorization_code_is_missing': 'Chýba autorizačný kód',
  'errors.unknown_payment_error': 'Počas platby došlo k neznámej chybe',
  'errors.already_in_use_by_auth_contact': 'Tento email sa už využíva kontaktom na autorizáciu',
  'roles.if_staff_stat_user': 'IF Statistical User',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': 'Boli ste odhlásení kvôli nečinnosti',
  'announcement.survey_description.do_think_people_are_lazy': 'Myslíte si, že mladí ľudia sú leniví? Či ste už mladí alebo starší, vyplňte prosím jeden z našich globálnych prieskumov a povedzte nám, čo si VY myslíte o dnešných mladých ľuďoch.',
  'announcement.survey_title.join_our_global_survey': 'Zapojte sa do nášho globálneho prieskumu',
  'announcement.survey_button.if_below_25': 'Ak máte medzi 16 a 25 rokov',
  'announcement.survey_button.if_over_25': 'Ak máte 25 rokov a viac',
  'moduleTitle.privacy_and_cookie_policy': 'Pravidlá ochrany osobných údajov a cookies',
  'label.we_have_made_some_important_changes': 'Urobili sme niekoľko dôležitých zmien v našich pravidlách ochrany osobných údajov a cookies a chceme, aby ste vedeli, čo to znamená pre vás a vaše dáta.',
  'button.i_agree': 'Súhlasím',
  'button.see_more_details': 'Pozrite viac podrobností',
  'label.the_cookie_settings_on_this': 'Nastavenia súborov cookie na tejto webovej lokalite sú nastavené na &quot;povolené&quot;, aby ste získali najlepší zážitok s prehliadaním. Ak budete naďalej používať tento web bez toho, aby ste zmenili nastavenia súborov cookie, alebo kliknete na tlačidlo &quot;Prijať&quot; tak s tým súhlasíte.',
  'label.after_your_rp_describe': '',
  'label.you_are_going_to_be_logged_out': ''
}
